<template>
  <div :menu-fix="true">
    <div class="wrapper">
      <breadcrumb
        :crumbs="[$t('reports.omsSalePerformance'), $t('text.lineItem')]"
      >
      </breadcrumb>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button type="default" size="mini" @click="download">
              {{ $t("action.download") }}
            </el-button>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        :loading="loading"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="total"
          :title="$t('payment.total')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <currency :code="row.currency"></currency>
            {{ row.total }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="payMethodName"
          :title="$t('payment.payMethodReceive')"
          min-width="100"
        ></vxe-table-column>
        <vxe-table-column
          field="paidAt"
          :title="$t('payment.paidAt')"
          min-width="110"
          sortable
        ></vxe-table-column>

        <vxe-table-column
          field="voucher"
          :title="$t('payment.voucher')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <thumbnail-text :srcs="row.voucher" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="explain"
          :title="$t('payment.explain')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number :content="row.explain" :number="8" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="ownerName"
          :title="$t('payment.ownerName')"
          min-width="80"
        />
        <vxe-table-column
          field="shopName"
          :title="$t('menu.shops')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.bargain.shopName }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('bargain.serialNo')"
          min-width="140"
        >
          <template v-slot="{ row }">
            <el-popover placement="right" width="300" trigger="click">
              <div>
                <div class="lineH24">
                  {{ $t("text.createAt") }}:
                  {{ row.bargain.createAt }}
                </div>
                <div class="lineH24">
                  {{ $t("menu.customers") }}:
                  {{ row.bargain.customerName }}
                </div>
              </div>
              <span slot="reference" class="popover-reference">
                {{ row.bargain.serialNo }}
              </span>
            </el-popover>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          <!-- 选中了
          <span class="strong">{{ selectRecordQty }} </span>条记录 -->
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { page, table } from "@/utils/mixins.js";
import ThumbnailText from "@/components/ThumbnailText";
import Currency from "@/components/Currency";
import Payment from "@/api/payment";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: { ThumbnailText, Currency },
  data() {
    return {
      searchForm: {},
      sorter: {
        sortBy: "payments_id",
        sortIndicator: "desc",
      },
      sorterMap: {
        paidAt: "payments_paidAt",
      },
    };
  },

  created() {
    const self = this;
    self.searchForm = self.$route.query;
  },
  methods: {
    //
    download() {
      const self = this;
      if (self.records.length == 0) {
        this.$message({
          message: self.$t("text.noData"),
          type: "warning",
        });
        return;
      }
      Payment.salesRevenueReportPayDetailExportExcel(self.searchForm).then(
        function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.downloadPrompt"),
              type: "success",
            });
            self.checkedRows = [];
            self.$eventHub.$emit("emitDownLoad");
          } else {
            self.$message.error(self.$t("prompt.downloadErr"));
          }
        }
      );
    },
    //======
    dataProvider(params) {
      return Payment.salesRevenueReportPayDetail(params);
    },
  },
};
</script>
<style >
.el-form-item__content {
  height: auto !important;
}
</style>